export default __webpack_public_path__ + "bc94ca294b492812fe67c7e144438454.png";